var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmazon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    width: "2rem",
    height: "2rem",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FF9900;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#221F1F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path8",
    className: "st0",
    d: "M133.57,105.81c-15.88,11.7-38.89,17.95-58.71,17.95c-27.78,0-52.8-10.28-71.72-27.37 c-1.49-1.34-0.15-3.18,1.63-2.13c20.42,11.88,45.67,19.03,71.75,19.03c17.59,0,36.94-3.64,54.73-11.19 C133.95,100.96,136.2,103.86,133.57,105.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10",
    className: "st0",
    d: "M140.17,98.26c-2.02-2.59-13.42-1.23-18.53-0.62c-1.56,0.19-1.8-1.17-0.39-2.14 c9.07-6.39,23.97-4.54,25.7-2.4c1.74,2.15-0.45,17.08-8.98,24.2c-1.31,1.09-2.56,0.51-1.97-0.94 C137.91,111.58,142.2,100.86,140.17,98.26"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    className: "st1",
    d: "M83.08,70.94c0,5.45,0.14,10-2.62,14.85c-2.22,3.94-5.75,6.36-9.69,6.36 c-5.38,0-8.51-4.1-8.51-10.14c0-11.93,10.69-14.1,20.81-14.1L83.08,70.94 M97.2,105.06c-0.93,0.83-2.26,0.89-3.31,0.33 c-4.65-3.86-5.47-5.65-8.03-9.33c-7.68,7.84-13.11,10.18-23.08,10.18c-11.77,0-20.95-7.27-20.95-21.82 c0-11.36,6.16-19.1,14.92-22.88c7.6-3.35,18.21-3.94,26.33-4.86v-1.81c0-3.33,0.26-7.27-1.69-10.14c-1.71-2.58-4.98-3.64-7.86-3.64 c-5.34,0-10.1,2.74-11.26,8.41c-0.24,1.26-1.16,2.5-2.42,2.56L46.26,50.6c-1.14-0.26-2.4-1.18-2.09-2.93 c3.13-16.46,18-21.42,31.31-21.42c6.81,0,15.71,1.81,21.09,6.97c6.81,6.36,6.16,14.85,6.16,24.08v21.82 c0,6.56,2.72,9.43,5.28,12.98c0.91,1.26,1.1,2.78-0.04,3.72c-2.86,2.38-7.94,6.81-10.73,9.29L97.2,105.06"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazon);
export default __webpack_public_path__ + "static/media/amazon.95ce7e305a49a1bb185c1901ca21dbec.svg";
export { ForwardRef as ReactComponent };